$(function(){
    $.fn.myPageSelector=function(options){
        var methods={
            "update":function(obj,dim_arr,is_init){
                var set=obj.data("myPageSelector");
                if(typeof dim_arr!="undefined"){
                    if(dim_arr[0]>0){
                        set.width=dim_arr[0];
                    }
                    if(dim_arr[1]>0){
                        set.height=dim_arr[1];
                    }
                    obj.data("myPageSelector", set);
                }
                var page=set.page;
                if(is_init || typeof dim_arr!="undefined"){
                    obj.find(">.mainContent").css({width:set.width+"px",height:set.height+"px"});
                }
                
                var pages=countPages(obj,set);
                
                
                page=Math.max(page,1);
                page=Math.min(page,pages);
                if(page!=set.page || is_init){
                    this.setPage(obj,page);
                }
                obj.find(">.mainNavi .nDet").html(page+" / "+pages);
            },
            "addHtml":function(obj,html){
                obj.find(">.mainContent>.myPSMove").append(html);
                this.update(obj);
            },
            setPage:function(obj,page){
                var set=obj.data("myPageSelector");
                var pages=countPages(obj,set);
                if(page<0){
                    page=pages+1-page;
                }
                
                page=Math.max(page,1);
                page=Math.min(page,pages);
                var arrLeft=obj.find(">.mainNavi .nLeft"),arrRight=obj.find(">.mainNavi .nRight");
                if(page==1){
                    arrLeft.addClass("unable");
                }
                else{
                    arrLeft.removeClass("unable");
                }
                if(page==pages){
                    arrRight.addClass("unable");
                }
                else{
                    arrRight.removeClass("unable");
                }
                set.page=page;
                obj.find(">.mainNavi .nDet").html(page+" / "+pages);
                var page_top=-(set.height-set.page_padding)*(page-1);
                obj.find(">.mainContent>.myPSMove").css("top",page_top);
                obj.data("myPageSelector", set);
                obj.attr({"data-page":page,"data-page_max":pages});
                obj.trigger("change",{"data-page":page,"data-page_max":pages});
            },
            getPageCount:function(obj){
                var set=obj.data("myPageSelector");
                return countPages(obj,set);
            },
            clear:function(obj){
                obj.html("").removeData("myPageSelector");
            }
            
        };
       
        function countPages(obj,set){
            var height=obj.find(".mainContent>.myPSMove").height();
            return Math.ceil(height/(set.height-set.page_padding));
        }
        function init(obj){
            var tobj=obj.children().clone(true);
            var html="";//=obj.html();
            // obj.find("script").remove();
            html=
            "<div class='mainContent'>"+
                "<div class='myPSMove'></div>"+
            "</div>"+
            "<div class='mainNavi'>"+
                "<div class='nLeft nArr'></div>"+
                "<div class='nDet'></div>"+
                "<div class='nRight nArr'></div>"+
            "</div>";
            obj.html(html);
            obj.find(">.mainContent>.myPSMove").append(tobj);
            var objNavi=obj.find(">.mainNavi");
            objNavi.find(".nLeft").click(function(){
                var set=obj.data("myPageSelector");
                methods.setPage(obj,set.page-1);
                _mySound.playSound("page_selector");
               
            }).end().find(".nRight").click(function(){
                var set=obj.data("myPageSelector");
                methods.setPage(obj,set.page+1);
                _mySound.playSound("page_selector");
            });
            methods.update(obj,undefined,1);
        }
        
        var last_this=$(this); 
        var arg =Array.prototype.slice.call(arguments,1);
        return $(this).each(function(key) {  
             var $this = $(this);
            if(methods[options]){  
                arg.unshift($this);
                return methods[options].apply($this,arg);
            }
            else if (typeof options === 'object' || !options){ 
                var data = $this.data("myPageSelector");  
                if(!data){    
                    $this.addClass("myPageSelector");
                    var settings = $.extend( {
                        height : 150,//for content
                        width: 300,//for content
                        page: 0,
                        page_padding:0
//                        repeat_last:0,//how many px show from previous page
                    }, options);
                    if($this.children().length>0){
                        data = $this.data("myPageSelector", settings);
                        init($this); 
                    }
                }                
                return;
            }
            else{
                $.error('myPageSelector: no method: '+ options);
            }
        });
    }; 
});